import dayjs, { Dayjs } from "dayjs";

export default function isValidDateRange(from: Dayjs | null, to: Dayjs | null) {
    const minDate = dayjs("1753-01-01");
    const maxDate = dayjs("9999-12-31");

    const tempFrom = dayjs(from);
    const tempTo = dayjs(to);

    if (
        !tempFrom.isValid() ||
        !tempTo.isValid() ||
        tempFrom.isBefore(minDate) ||
        tempFrom.isAfter(maxDate) ||
        tempTo.isBefore(minDate) ||
        tempTo.isAfter(maxDate)
    ) {
        return false;
    }
    return true;
}